import React from 'react';
import PropTypes from 'prop-types';
import Panel from 'panelComponents/Panel';
import ChargeOptionsList from 'chargeComponents/ChargeOptionsList';

const ChargesPanel = (props) => {

    const {
        chargeOptionDetails,
        serviceTypeId,
        clearWorkOrderDetail,
        orderId,
        header,
        chargeActions,
        user,
        accountNumber,
        style,
        showRefreshButton,
        detailKey,
        orderStatus,
        paddingLeft,
        paddingRight,
        customerDetails,
        equipmentDetails,
        equipmentDetailsComplete
    } = props;
    let chargeOptions = null,
        chargeOptionDetailsLoading = false;

    if (chargeOptionDetails) {
        chargeOptions = chargeOptionDetails.get('details');
        chargeOptionDetailsLoading = chargeOptionDetails.get('loading');
    }

    return (

        <Panel
            style={style}
            paddingLeft={paddingLeft}
            paddingRight={paddingRight}
            loading={chargeOptionDetailsLoading}
            hasDetails={chargeOptions && chargeOptions.count() > 0}
            orderId={orderId}
            detailKey={detailKey}
            showRefreshButton={showRefreshButton}
            clearWorkOrderDetail={clearWorkOrderDetail}
            header={header}>

            <div>
                <ChargeOptionsList
                    orderStatus={orderStatus}
                    accountNumber={accountNumber}
                    user={user}
                    chargeOptions={chargeOptionDetails}
                    orderId={orderId}
                    chargeActions={chargeActions}
                    serviceTypeId={serviceTypeId}
                    customerDetails={customerDetails}
                    equipmentDetails={equipmentDetails}
                    equipmentDetailsComplete={equipmentDetailsComplete}
                />
            </div>
        </Panel>
    );
};

ChargesPanel.propTypes = {
    chargeOptionDetails: PropTypes.object,
    serviceTypeId: PropTypes.string,
    orderStatus: PropTypes.object,
    clearWorkOrderDetail: PropTypes.func,
    orderId: PropTypes.string,
    header: PropTypes.string,
    chargeActions: PropTypes.object,
    user: PropTypes.object,
    accountNumber: PropTypes.string,
    style: PropTypes.object,
    showRefreshButton: PropTypes.bool,
    detailKey: PropTypes.string,
    paddingLeft: PropTypes.string,
    paddingRight: PropTypes.string,
    equipmentDetailsComplete: PropTypes.object,
    equipmentDetails: PropTypes.object
};
export default ChargesPanel;



// WEBPACK FOOTER //
// ./src/components/charges/ChargesPanel.js